<app-admin-dashboard>
  <p-card header="Reporte Programas">
    <form [formGroup]="form">
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="profileType" style="font-weight: bolder"
            >Tipo de perfil *</label
          >
          <p-dropdown
            id="profileType"
            [ngModelOptions]="{standalone: true}"
            [options]="profileTypeOptions"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            filterBy="label"
            [showClear]="false"
            [(ngModel)]="selectedProfileType"
            (onChange)="onChangeProfileType($event.value)"
            placeholder="Tipo de perfil"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="p-fluid formgrid mr-2 ml-2 grid" *ngIf="selectedProfileType === 1 && userDownload">
        <div class="field col-6">
          <label for="exporterUsername" style="font-weight: bolder"
            >Exportador *</label
          >
          <p-dropdown
            id="exporterUsername"
            formControlName="exporterUsername"
            [options]="exporters"
            optionValue="contactEmail"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="false"
            (onChange)="onChangeExporter()"
            placeholder="Exporter"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="p-fluid formgrid mr-2 ml-2 grid" *ngIf="selectedProfileType === 2 && userDownload">
        <div class="field col-6">
          <label for="importerUsername" style="font-weight: bolder"
            >Importador *</label
          >
          <p-dropdown
            id="importerUsername"
            formControlName="importerUsername"
            [options]="importers"
            optionValue="contactEmail"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="false"
            (onChange)="onChangeExporter()"
            placeholder="Importer"
          >
          </p-dropdown>
        </div>
      </div>

      <div class="p-fluid formgrid mr-2 ml-2 grid" *ngIf="selectedProfileType === 5 && companyDownload">
        <div class="field col-6">
          <label for="company" style="font-weight: bolder"
            >Empresa *</label
          >
          <p-dropdown
            id="company"
            formControlName="companyId"
            [options]="companies"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="false"
            (onChange)="onChangeExporter()"
            placeholder="Empresa"
          >
          </p-dropdown>
        </div>
      </div>
    </form>

    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="field col-3">
        <label class="font-bold">Año inicial *</label>
        <p-dropdown
          [options]="years"
          [(ngModel)]="startYear"
          placeholder="Año"
          [showClear]="true"
          (onChange)="onStartYearChange($event.value)"
        >
        </p-dropdown>
      </div>

      <div class="field col-3">
        <label class="font-bold">Año final *</label>
        <p-dropdown
          [options]="endYearOptions"
          (onChange)="onEndYearChange($event.value)"
          [(ngModel)]="endYear"
          placeholder="Año"
          [showClear]="true"
          [disabled]="!startYear"

        >
        </p-dropdown>
      </div>
    </div>
    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="col-3">
        <p-button
          type="button"
          pRipple
          pTooltip="Excel"
          (click)="downloadExcel()"
          [loading]="loadingBtnDownload"
          [disabled]="!enableExportProgramsButton"
          tooltipPosition="bottom"
          [style]="{ width: 'fit-content' }"
        >
          {{ "UserPages.PackingListView.ExportExcel" | translate }}
        </p-button>
      </div>
    </div>
  </p-card>
</app-admin-dashboard>
